var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-grow-0 px-4 py-5 border-b border-gray-200 sm:px-6"},[_c('h3',{staticClass:"text-lg font-medium text-gray-900 leading-6"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }